/*
 * @Author: 丨小小风离丨
 * @Date: 2025-06-25 15:22:58
 * @LastEditTime: 2025-06-26 17:02:37
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\page\admissionInquiry\index.tsx
 * @Description: 
 */
import { CheckIdCard, replyCN } from '@/util/public';
import { Form, Spin, message } from 'antd';
import { LgButton, LgInput } from 'lancoo-web-ui';
import { useState } from 'react';
import './index.scss';
import { CommmonGet } from '@/util/network/api';
import { selectSchoolInfo } from '../../store/reducers/schoolInfo';
import { useSelector } from 'react-redux';

export default () => {
    const [form] = Form.useForm();
    const schoolInfo = useSelector(selectSchoolInfo); // 学校信息
    // 表单显示
    const [formShow, setFormShow] = useState<boolean>(false);
    // 刷新
    const [isloading, setIsloading] = useState<boolean>(false);
    const [data, setData] = useState<any>([]);
    const [dataFalg, setDataFalg] = useState<boolean>(false);


    const submit = () => {
        form.validateFields().then((res: any) => {
            const formData = form.getFieldsValue();
            setIsloading(true);
            setDataFalg(false);
            CommmonGet('/portal/homepage/ownerAdmissionStatus', formData).then((res: any) => {
                //console.log('查询结果:', res)
                //console.log('data:', res?.data)
                // 所有数据的ems都为空时，视为查询不到录取信息
                const hasEms = res.data && res.data.length > 0 && res.data.some((ele: any) => {
                    //console.log('单条数据esm:', ele?.esm, '类型:', typeof ele?.esm);
                    return ele?.esm && String(ele.esm).trim() !== '';
                });
                if (hasEms) {
                    setFormShow(true);
                    setData(res.data);
                    // setData([...res.data, ...res.data]);
                } else {
                    setData([]);
                    setDataFalg(true);
                    // message.destroy();
                    // message.warning('未查询到相关录取数据，请确认信息是否正确！');
                }
            }).catch(() => {
                message.destroy();
                message.error('查询失败，请联系管理员！');
            }).finally(() => {
                setIsloading(false);
            })
        }).catch((err: any) => {
            console.log(err)
        })
    };

    return (
        <Spin spinning={isloading} className='wjz_spin_div'>
            <div className={`admissionInquiry ${formShow ? 'hide' : ''}`}>
                <h1>锦州师范高等专科学校录取查询系统</h1>
                <Form
                    className={`basic`}
                    labelCol={{ span: 10 }}
                    // wrapperCol={{ span: 6 }}
                    form={form}
                >
                    <Form.Item
                        label={"姓名"}
                        name="userName"
                        rules={[{ required: true, message: '姓名不能为空!' }]}
                    >
                        <LgInput
                            maxLength={25}
                            placeholder="请输入姓名"
                            autoComplete='off'
                        />
                    </Form.Item>
                    <Form.Item
                        label={"考生号"}
                        name="examineeNumber"
                        rules={[{ required: true, message: '考生号不能为空!' }]}
                    >
                        <LgInput
                            maxLength={25}
                            placeholder="请输入考生号"
                            autoComplete='off'
                        />
                    </Form.Item>
                    <Form.Item
                        label="身份证号"
                        name="idCard"
                        rules={[
                            {
                                required: true,
                                message: '身份证号不能为空!'
                            },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || !CheckIdCard(value)) {
                                        return Promise.resolve();
                                    } else if (value && CheckIdCard(value)) {
                                        return Promise.reject(new Error(CheckIdCard(value)));
                                    }
                                    return Promise.reject(new Error('身份证格式有误'));
                                },
                            }),
                        ]}
                        getValueFromEvent={
                            (event) => {
                                return replyCN(event)
                            }
                        }
                    >
                        <LgInput
                            placeholder="请输入身份证号"
                            readOnly={false}
                            disabled={false}
                            autoComplete='off'
                            maxLength={18}
                        />
                    </Form.Item>

                    <Form.Item className='submit'>
                        <LgButton size='default' backgroundType='opacification' type='info' onClick={submit}>立即查询</LgButton>
                        {dataFalg && <div className='tip_error'>未查询到相关录取数据，请确认信息是否正确！</div>}
                    </Form.Item>
                </Form>
                {formShow && <>
                    {/* <div className='title'>恭喜你已被{schoolInfo.schoolName}录取！</div> */}
                    <div className='title'>恭喜你已被锦州师范高等专科学校录取！</div>
                    {data.map((ele, index) => {
                        return <div className={`result ${data.length === 1 ? 'single' : ''}`} key={ele?.idCard || index}>
                            <div className='content'>
                                <div className='item'>
                                    <div className='label'>考生号：</div>
                                    <div className='value'>{ele?.examineeNumber || '--'}</div>
                                </div>
                                <div className='item'>
                                    <div className='label'>姓名：</div>
                                    <div className='value name'>{ele?.userName || '--'}</div>
                                </div>
                                <div className='item'>
                                    <div className='label'>身份证号：</div>
                                    <div className='value'>{ele?.idCard || '--'}</div>
                                </div>
                                <div className='item'>
                                    <div className='label'>录取专业：</div>
                                    <div className='value'>{ele?.major || '--'}</div>
                                </div>
                                <div className='item'>
                                    <div className='label'>EMS快递号：</div>
                                    <div className='value'>{ele?.esm || '--'}</div>
                                </div>
                                {data.length > 1 && <div className='item'>
                                    <div className='label'></div>
                                    <div className='value'></div>
                                </div>}
                                <div className='item' style={{ width: '100%' }}>
                                    <div className='label'>通知书邮寄地址：</div>
                                    <div className='value'>{ele?.esmAddress || '--'}</div>
                                </div>
                            </div>
                        </div>
                    })}
                    <LgButton
                        size='super'
                        backgroundType='translucent'
                        border
                        type='info'
                        onClick={() => setFormShow(false)}
                        className='back_button'
                    >
                        返回
                    </LgButton>
                </>}
            </div>
        </Spin>
    )
}
